"use client";

import { lazy, Suspense } from "react";
import CorrectedLandingContent from "@/modules/landing/components/CorrectedLandingContent";
import { MarketingPageShell } from "@/modules/landing/components/MarketingPageShell";
import AppStartupScreen from "@/shared/components/AppStartupScreen";
import { useAppAuthSnapshot } from "@/shared/providers/AppAuthSnapshot";

const AuthenticatedLandingPage = lazy(() => import("@/modules/landing/pages/LandingPage"));

export default function PublicLandingPage() {
  const { hasHydrated, isAuthenticated } = useAppAuthSnapshot();

  if (hasHydrated && isAuthenticated) {
    return (
      <Suspense
        fallback={<AppStartupScreen message="Preparing your Carevinco experience..." title="Loading Carevinco" />}
      >
        <AuthenticatedLandingPage />
      </Suspense>
    );
  }

  return (
    <MarketingPageShell variant="corrected">
      <CorrectedLandingContent />
    </MarketingPageShell>
  );
}
